"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PaginationItem = _ref => {
  let {
    number,
    onClick,
    isActive = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-pagination__item"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)("p-pagination__link", {
      "is-active": isActive
    }),
    onClick: onClick,
    "aria-current": isActive ? "page" : undefined,
    type: "button"
  }, number));
};
var _default = exports.default = PaginationItem;